import { render, staticRenderFns } from "./AExpansionPanel.vue?vue&type=template&id=6f2361b9&scoped=true&"
import script from "./AExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./AExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./AExpansionPanel.vue?vue&type=style&index=0&id=6f2361b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2361b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel})
